import { render, staticRenderFns } from "./leftC-temp3.vue?vue&type=template&id=3e12d199&scoped=true"
import script from "./leftC-temp3.vue?vue&type=script&lang=js"
export * from "./leftC-temp3.vue?vue&type=script&lang=js"
import style0 from "./leftC-temp3.vue?vue&type=style&index=0&id=3e12d199&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e12d199",
  null
  
)

export default component.exports